/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {ModalWrapperComponent as ɵa} from './components/modal-wrapper.component';